import React from "react"

import { cn } from "../../../utils/cn.ts"

interface PortalPageHeaderProps {
  title: React.ReactNode
  subtitle?: React.ReactNode
  actions?: React.ReactNode
  className?: string
}

/** The one page-title row every portal screen shares — a 30px title, an
 * optional 16px supporting line, and right-aligned actions that stay on the
 * same row while there's room and wrap below it once there isn't. Used for
 * Home's greeting and every other page's plain title alike, so titles never
 * drift to a different size or alignment from one module to the next. */
export function PortalPageHeader({ title, subtitle, actions, className }: PortalPageHeaderProps) {
  return (
    <div className={cn("mb-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between", className)}>
      <div className="min-w-0">
        <h1 className="text-left text-[30px] font-semibold leading-tight text-gray-900">
          {title}
        </h1>
        {subtitle && <p className="mt-1 text-base text-gray-500">{subtitle}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2.5">{actions}</div>}
    </div>
  )
}
